export default __webpack_public_path__ + "static/media/co2Savedicon.879d3646.svg";